import img1 from "./img/1.png";
import img2 from "./img/2.jpg";
import img3 from "./img/3.jpg";
import img4 from "./img/4.jpg";
import img5 from "./img/5.jpg";
import img6 from "./img/6.jpg";
const products = [
    {
      title: "CCTV Cameras",
      description: "High-definition cameras with night vision and motion detection, ensuring 24/7 surveillance.",
      image: img1, 
    },
    {
      title: "Access Control Devices",
      description: "Biometric scanners and keycard systems designed for secure access management.",
      image: img2, 
    },
    {
      title: "Wireless Alarm Systems",
      description: "Complete intrusion detection solutions with mobile app integration and easy installation.",
      image: img3, 
    },
    {
      title: "Fire and Smoke Detectors",
      description: "Sensitive detectors for early fire alerts, compliant with international safety standards.",
      image: img4, 
    },
    {
      title: "Smart Door Locks",
      description: "Advanced keyless entry systems with features like fingerprint recognition and smartphone control.",
      image: img5, 
    },
    {
      title: "Video Doorbells",
      description: "Smart doorbells with live video streaming and real-time visitor notifications.",
      image: img6, 
    },
  ];
export default products;